export type LoadState = 'loading' | 'success' | 'error';

/** Page numbers for `<app-pagination [getPageNumbers]>`. `-1` marks an ellipsis. */
export function buildPageNumbers(current: number, total: number): number[] {
  const delta = 2;
  const range: number[] = [1];
  if (total <= 1) return range;
  for (let i = current - delta; i <= current + delta; i++) {
    if (i > 1 && i < total) range.push(i);
  }
  range.push(total);

  const result: number[] = [];
  let prev: number | undefined;
  for (const i of range) {
    if (prev !== undefined) {
      if (i - prev === 2) result.push(prev + 1);
      else if (i - prev !== 1) result.push(-1);
    }
    result.push(i);
    prev = i;
  }
  return result;
}

export function getStartItem(currentPage: number, itemsPerPage: number, totalItems: number): number {
  return totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
}

export function getEndItem(currentPage: number, itemsPerPage: number, totalItems: number): number {
  return Math.min(currentPage * itemsPerPage, totalItems);
}
